/**
 * Created by jonas on 2022-06-15.
 */
import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheCage} from "../../TheCage";
import {TheCageSound} from "../../sound/TheCageSound";
import {TheCageGameMode} from "../../server/TheCageGameMode";
import {TheCageSymbol} from "../../reels/TheCageSymbol";
import {TheCageStatics} from "../../config/TheCageStatics";
import {GSAPUtils} from "../../utils/GSAPUtils";


export class FreeSpinMultiplierFeature implements SimplePresentation {
    name:string = "FreeSpinMultiplierFeature";

    constructor() {
    }

    private multiplierTargetSymbol() {
        return (<TheCageSymbol>TheCage.freeSpinReelView.avalancheMatrixModel.getSymbolAt({x:4, y:0}).positionable).symbolName;
    }

    shouldRun():boolean {
        //return true;
        return TheCage.model.data.featuresActive[0] &&
            TheCage.model.data.featuresUsedBefore[0] != TheCage.model.data.featuresUsedAfter[0] &&
            TheCageStatics.isLowSymbol(this.multiplierTargetSymbol());
    }

    start(controller:SimplePresentationRunnerController):void {

        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => {
                controller.finish();
            }});
        tl.add(() => controller.setSkipCallback(() => {
            tl.timeScale(2) ;
        }));


       const transforms:gsap.core.Timeline[][] = [[], [], [], [], [], [], []];

       TheCage.freeSpinReelView.avalancheMatrixModel.getAllSymbolsWithName(this.multiplierTargetSymbol()).forEach((sym) => {
           transforms[Math.abs(4 - sym.reelId)].push((<TheCageSymbol>sym.positionable).setMultiplier());
        });

        const reelTimelines = transforms.filter((transformTl) => transformTl.length > 0)
                                        .map((transformTl) => GSAPUtils.createTimelineFromArray(transformTl, '<'));
        tl.add(TheCage.freeSpinReelView.features.useMultiplier());
        tl.add(GSAPUtils.createTimelineFromArray(reelTimelines, '<0.1'), );

        tl.add(() => {}, '>0.5');
    }
}
